/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Moar, MoarInterface } from "../Moar";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "authority",
        type: "address",
      },
      {
        internalType: "address",
        name: "admin",
        type: "address",
      },
      {
        internalType: "address",
        name: "royaltyAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ApprovalToOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "ArrayLengthMismatch",
    type: "error",
  },
  {
    inputs: [],
    name: "BurnningInactive",
    type: "error",
  },
  {
    inputs: [],
    name: "ContractBidder",
    type: "error",
  },
  {
    inputs: [],
    name: "DuplicatedMint",
    type: "error",
  },
  {
    inputs: [],
    name: "ExceedAuctionSupply",
    type: "error",
  },
  {
    inputs: [],
    name: "ExceedDiamondHandSupply",
    type: "error",
  },
  {
    inputs: [],
    name: "ExceedMaxSupply",
    type: "error",
  },
  {
    inputs: [],
    name: "ExceedMaxTicket",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidPayment",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidSaleOn",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidSignature",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidTime",
    type: "error",
  },
  {
    inputs: [],
    name: "MetadataFrozen",
    type: "error",
  },
  {
    inputs: [],
    name: "NonAdmin",
    type: "error",
  },
  {
    inputs: [],
    name: "NonERC721ReceiverImplementer",
    type: "error",
  },
  {
    inputs: [],
    name: "NonExistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrOperator",
    type: "error",
  },
  {
    inputs: [],
    name: "RoyaltyPercentageExceed",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferDeactive",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferLocked",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferLockedByAdmin",
    type: "error",
  },
  {
    inputs: [],
    name: "WithdrawFailed",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAddress",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "locked",
        type: "bool",
      },
    ],
    name: "LockTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "refundFailed",
    type: "event",
  },
  {
    inputs: [],
    name: "DHDAMaxSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DHDATotalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DIAMOND_HAND_ID",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DUTCH_AUCTION_DROP_INTERVAL",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DUTCH_AUCTION_DROP_PER_STEP",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DUTCH_AUCTION_END_PRICE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DUTCH_AUCTION_MAX_TICKET",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DUTCH_AUCTION_PRICE_CURVE_LENGTH",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DUTCH_AUCTION_START_PRICE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "burningActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tierIds",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "tierStartTimes",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "tierDurations",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "tierMaxTicketNums",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "tierTicketPrices",
        type: "uint256[]",
      },
    ],
    name: "configSales",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "diamondHandMaxSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "ticketNum",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "diamondHandMint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "ticketNum",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "dutchAuctionMint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "dutchAuctionPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "dutchAuctionStartTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "locked",
        type: "bool",
      },
    ],
    name: "lockTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
      {
        internalType: "bool[]",
        name: "locks",
        type: "bool[]",
      },
    ],
    name: "lockTransfers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "maxSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "metadataFrozen",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "tos",
        type: "address[]",
      },
    ],
    name: "privateMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "provenance",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "publicMints",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "saleOn",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address",
      },
    ],
    name: "setAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "authority",
        type: "address",
      },
    ],
    name: "setAuthority",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "startTime",
        type: "uint256",
      },
    ],
    name: "setDutchAuctionStartTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "provenance_",
        type: "bytes32",
      },
    ],
    name: "setProvenance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "royaltyReceiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyPercentage",
        type: "uint256",
      },
    ],
    name: "setRoyaltyInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tiers",
    outputs: [
      {
        internalType: "uint256",
        name: "startTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxTicketNum",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "ticketPrice",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "flag",
        type: "uint256",
      },
    ],
    name: "toggleFlag",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "transferDeactive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "transferLocks",
    outputs: [
      {
        internalType: "enum MoarBase.LockStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tierId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "ticketNum",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "whitelistMint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type MoarConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MoarConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Moar__factory extends ContractFactory {
  constructor(...args: MoarConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "Moar";
  }

  deploy(
    authority: string,
    admin: string,
    royaltyAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Moar> {
    return super.deploy(
      authority,
      admin,
      royaltyAddress,
      overrides || {}
    ) as Promise<Moar>;
  }
  getDeployTransaction(
    authority: string,
    admin: string,
    royaltyAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      authority,
      admin,
      royaltyAddress,
      overrides || {}
    );
  }
  attach(address: string): Moar {
    return super.attach(address) as Moar;
  }
  connect(signer: Signer): Moar__factory {
    return super.connect(signer) as Moar__factory;
  }
  static readonly contractName: "Moar";
  public readonly contractName: "Moar";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MoarInterface {
    return new utils.Interface(_abi) as MoarInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Moar {
    return new Contract(address, _abi, signerOrProvider) as Moar;
  }
}
